export default __webpack_public_path__ + "static/media/Thumb_Top_01.5fd540d9.png";